export const dateTimeFormat = 'D-MMM-YY HH:mm'
export const dateTimeFormatSec = 'D-MMM-YY HH:mm:ss'
